module.exports = __webpack_public_path__ + "static/media/3-male.069de220.png";